import SMBookMarket from "./SMBookMarket";

export default SMBookMarket;